module.exports = __webpack_public_path__ + "static/media/Alie-White.915e8b01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/Alie-White.svg
// module id = 3794
// module chunks = 0